import { ActivatedRoute, Router } from '@angular/router';
import { PassengerFlightInfo, Flight } from '@ibe/models';
import { BookingService, MybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';

export abstract class ExtraSidebar {
	protected _flight: any;
	protected _same: boolean;
	protected _passengers: PassengerFlightInfo[];

	protected constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected bookingService: BookingService,
		protected mybService: MybService
	) { }

	// ACCESSORS

	get flight(): any { return this._flight; }
	set flight(value: any) { this._flight = value; }

	get same(): boolean { return this._same; }
	set same(value: boolean) { this._same = value; }

	get passengers(): PassengerFlightInfo[] { return this._passengers; }
	set passengers(value: PassengerFlightInfo[]) { this._passengers = value; }

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	TAP_handleClose() { this.closeSidebar(); }

	TAP_handleDone() { this.showLoadingCloseSidebar(); }

	/** Show loading and close sidebar */
	private showLoadingCloseSidebar() {
		this.sidebarService.showLoadingAndCloseSidebar();
	}


	// OTHER REUSABLE METHODS

	/**
	 * @param passenger {Object} Passenger
	 * @returns Seat assigned to @passenger
	 */
	TAP_passengerSeat(passenger: PassengerFlightInfo): string {
		return passenger.seat;
	}

	/**
	 * @param passenger {Object} Passenger
	 * @return total bags assigned to @passenger
	 */
	TAP_passengerBags(passenger: PassengerFlightInfo): number {
		return passenger.luggage;
	}

	/** Returns a string that briefly describes the flight route */
	TAP_printRoute(): string {
		if (this.flight) {
			const departure = this.flight.departure.airport.location.city,
				arrival = this.flight.arrival.airport.location.city;

			return `${departure} — ${arrival}`;
		} else {
			return '';
		}
	}

	/**
	 * @param passenger {Object} Passenger
	 * Returns a string with passenger's name
	 */
	TAP_printPassengerName(
		passenger: PassengerFlightInfo
	): string {
		return !passenger.passenger.name ? passenger.passenger.type + ' ' + passenger.passenger.typeCount : passenger.passenger.name;
	}

	/**
	 * @param passenger {Object} Passenger
	 * Returns a string with passenger's name
	 */
	TAP_printInitialsPassengerName(
		passenger: PassengerFlightInfo
	): string {
		return passenger.passenger.name ? passenger.passenger.firstName.charAt(0).toUpperCase() + passenger.passenger.lastName.charAt(0).toUpperCase() : `${passenger.passenger.type.charAt(0).toUpperCase()}${passenger.passenger.typeCount}`;
	}

}
